import React from "react";

import {
  Autocomplete,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";

import { GreyPallet } from "../../../config/styles";

import MainText from "../../MainText";

type AutocompleteMainProps = {
  name: string;
  value: string | undefined;
  onChange: (value: string) => void;
  options: string[];
  onSubmit?: () => void;
  loading?: boolean;
  disabled?: boolean;
  small?: string | JSX.Element;
  autoComplete?: boolean;
  shrink?: boolean;
};

export default function AutocompleteMain({
  name,
  value,
  onChange,
  disabled,
  options,
  small,
  autoComplete,
  shrink = true,
}: AutocompleteMainProps) {
  const [fieldValue, setFieldValue] = React.useState<string | undefined>("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const eventValue = event.currentTarget.value as string;
    setFieldValue(eventValue);
    onChange(eventValue);
  };

  const old = (
    <FormControl
      fullWidth
      sx={{
        "& .MuiFormLabel-root": {
          fontWeight: "bold",
          color: `${GreyPallet.Regular} !important`,
        },
        mb: 2,
      }}
      variant="outlined"
    >
      <InputLabel>{name}</InputLabel>
      <OutlinedInput
        value={value}
        disabled={disabled}
        onChange={handleChange}
        type={"text"}
        label={name}
        autoComplete={autoComplete ? "on" : "off"}
        sx={{
          borderRadius: "15px",

          height: 60,
          fontWeight: "bold",
          fontSize: 16,
          color: GreyPallet.Regular,

          "& .MuiSvgIcon-root": {
            fontSize: 26,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "3px !important",
            borderColor: `${GreyPallet.Light} !important`,
            borderStyle: "solid",
            "& .Mui-focused": {
              borderColor: `${GreyPallet.Regular} !important`,
            },
          },
        }}
      />
      {small ? (
        <Box mt={1}>
          <MainText size="small" color="regular">
            {small}
          </MainText>
        </Box>
      ) : null}
    </FormControl>
  );

  const trythis = (
    <Autocomplete
      id="free-solo-demo"
      freeSolo
      options={[
        { label: "spott", year: 1 },
        { label: "rating", year: 2 },
      ].map((option) => option.label)}
      renderInput={(params) => <TextField {...params} label="freeSolo" />}
    />
  );

  const ICON_LIST = [
    { icon: "invoice", name: "Boleto" },
    { icon: "ap", name: "Ap" },
    { icon: "home", name: "Aluguel" },
    { icon: "fix", name: "Conserto" },
    { icon: "internet", name: "Internet" },
    { icon: "water", name: "Água" },
    { icon: "light", name: "Luz" },
  ];

  const ap = (
    <Autocomplete
      freeSolo
      id="free-solo-demo"
      style={{ flex: 1 }}
      options={ICON_LIST.map((item) => item.name)}
      onChange={(e, v) => {
        // setTitleField(String(v || ""));
        const foundValue = ICON_LIST.find((item) => item.name === v);
        // if (foundValue) setIconField(foundValue.icon);
      }}
      // value={titleField || ""}
      renderOption={(props, option) => {
        const foundValue = ICON_LIST.find((item) => item.name === option);
        return (
          <Box component="li" {...props}>
            {/* <Util.BillIcon name={foundValue?.icon} sx={{ mr: 2 }} fontSize="small" /> */}
            {option}
          </Box>
        );
      }}
      ListboxProps={{ style: { maxHeight: 200 } }}
      renderInput={(params) => (
        <TextField
          {...params}
          // value={titleField || ""}
          // onChange={(e) => setTitleField(e.target.value)}
          label="Título"
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    />
  );

  return (
    <FormControl
      fullWidth
      sx={{
        "& .MuiFormLabel-root": {
          fontWeight: "bold",
          color: `${GreyPallet.Regular} !important`,
          top: "2px",
        },
        "& .MuiOutlinedInput-root": {
          height: "100%",
        },
        mb: 2,
      }}
      variant="outlined"
    >
      <Autocomplete
        freeSolo
        options={options}
        onChange={(event: any, newValue: string | null) => onChange(newValue || "")}
        value={value}
        // inputValue={fieldValue}
        onInputChange={(event: any, newValue: string | null) => onChange(newValue || "")}
        sx={{
          height: 60,
          fontWeight: "bold",
          fontSize: 16,
          color: GreyPallet.Regular,

          "& .MuiSvgIcon-root": {
            fontSize: 26,
          },
          "& .MuiAutocomplete-endAdornment ": {
            top: "calc(50% - 17px)",
          },

          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "15px",
            borderWidth: "3px !important",
            borderColor: `${GreyPallet.Light} !important`,
            borderStyle: "solid",
            "& .Mui-focused": {
              borderColor: `${GreyPallet.Regular} !important`,
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            autoComplete={autoComplete ? "on" : "new-password"}
            label={name}
            sx={{
              "& .MuiAutocomplete-input": {
                fontWeight: "bold",
                color: `${GreyPallet.Regular} !important`,
              },
              borderRadius: "15px",

              height: 60,
              fontWeight: "bold",
              fontSize: 16,
              color: GreyPallet.Regular,

              "& .MuiSvgIcon-root": {
                fontSize: 26,
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderWidth: "3px !important",
                borderColor: `${GreyPallet.Light} !important`,
                borderStyle: "solid",
                "& .Mui-focused": {
                  borderColor: `${GreyPallet.Regular} !important`,
                },
              },
            }}
            {...params}
            InputLabelProps={{ ...params.InputLabelProps, shrink: shrink }}
          />
        )}
      />
    </FormControl>
  );
}
